export default __webpack_public_path__ + "static/moon-702e0e6444d4bf7ebb9586361cecdc95.png";